import handleFetchErrors from '@adsk/bim360-matrix-react-helpers/es/handleFetchErrors';

const getHeaders = token => ({
  Authorization: `Bearer ${token}`,
  Accept: 'application/json',
  'Content-Type': 'application/json'
});

export default {
  queryAssets: async (baseUrl, projectId, token, nextUrl, queryString) =>
    handleFetchErrors(
      await fetch(nextUrl || `${baseUrl}/${projectId}/assets${queryString}`, {
        headers: getHeaders(token)
      })
    ).json(),
  batchGetAssets: async (baseUrl, projectId, token, ids) =>
    handleFetchErrors(
      await fetch(`${baseUrl}/${projectId}/assets:batch-get`, {
        method: 'POST',
        headers: getHeaders(token),
        body: JSON.stringify({
          ids
        })
      })
    ).json(),
  batchGetStatuses: async (baseUrl, projectId, token, ids) =>
    handleFetchErrors(
      await fetch(`${baseUrl}/${projectId}/asset-statuses:batch-get?includeDeleted=true`, {
        method: 'POST',
        headers: getHeaders(token),
        body: JSON.stringify({
          ids
        })
      })
    ).json()
};
